export const APP_MODULE_ROLES = {
  DALJINSKO: 'module_district_heating',
  SONCNO: 'module_photovoltaics',
  TOPLOTNO: 'module_solar_thermal_collector',
};

// (opcijsko, če kje rabiš tip)
export type AppModuleRoleValue =
  | 'module_district_heating'
  | 'module_photovoltaics'
  | 'module_solar_thermal_collector';